import { render, staticRenderFns } from "./tm-carousel.vue?vue&type=template&id=c8ec1ecc&scoped=true&"
import script from "./tm-carousel.vue?vue&type=script&lang=ts&"
export * from "./tm-carousel.vue?vue&type=script&lang=ts&"
import style0 from "./tm-carousel.vue?vue&type=style&index=0&id=c8ec1ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ec1ecc",
  null
  
)

export default component.exports